import { createUserGateway, type GaryClient } from '@mntn/gary-client'
import { useCallback, useEffect, useState } from 'react'
import type { AppSession } from '../session/session-provider.tsx'
import { createAppSession } from './app-session.ts'

export const useSessionLoader = ({
  garyClient,
  isAuthenticated,
  isAuthLoaded,
}: {
  garyClient: GaryClient
  isAuthenticated: boolean | undefined
  isAuthLoaded: boolean
}) => {
  const [session, setSession] = useState<AppSession | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const loadSession = useCallback(async () => {
    if (!isAuthLoaded) {
      return
    }

    if (isAuthLoaded && !isAuthenticated) {
      setIsLoaded(true)
      return
    }

    try {
      const userGateway = createUserGateway(garyClient)

      const garySession = await userGateway.getSession()

      const newSession = createAppSession(garySession)

      setSession(newSession)
    } catch (err) {
      const errorObj = err instanceof Error ? err : new Error('Unknown error')
      console.error('loadSession failed', errorObj)
      setSession(null)
      setError(errorObj)
    } finally {
      setIsLoaded(true)
    }
  }, [isAuthLoaded, isAuthenticated, garyClient])

  useEffect(() => {
    loadSession()
  }, [loadSession])

  return {
    session,
    isLoaded,
    error,
    reloadSession: loadSession,
    setSession,
  }
}
